import api from "@/services/api";
import blob from "@/services/blob";

export default {
  // program
  get_program_file(payload) {
    return blob
      .post("programs/" + payload.id + "/download/", payload)
      .then(response => response.data);
  },
  get_program(payload) {
    return api.get("programs/" + payload.id + "/", payload).then(response => response.data);
  },
  save_program(payload) {
    return api.put("programs/" + payload.id + "/", payload).then(response => response.data);
  },
  delete_program(payload) {
    return api.delete("programs/" + payload.id + "/", payload).then(response => response.data);
  },
  clone_program(payload) {
    return api.post("programs/" + payload.id + "/clone/", payload).then(response => response.data);
  },
  create_program(payload) {
    return api.post("programs/", payload).then(response => response.data);
  },
  // patient
  delete_patient(payload) {
    return api.delete("patients/" + payload.id + "/").then(response => response.data);
  },
  get_patients(payload) {
    return api.get("patients/", { params: payload }).then(response => response.data);
  },
  get_patient(payload) {
    return api
      .get("patients/" + payload.id + "/")
      .then(response => response.data);
  },
  create_patient(payload) {
    return api.post("patients/", payload).then(response => response.data);
  },
  edit_patient(payload) {
    return api.put("patients/" + payload.id + "/", payload).then(response => response.data);
  },
  // others
  get_excercises_by_tag_name(payload) {
    return api
      .post("get_excercises_by_tag_name/", payload)
      .then(response => response.data);
  }
};
